class MyDataHelps {
    constructor() {
        this.allowedApplicationHosts = [
            'localhost',
            'careevolution.com',
            'internal',
            'b3-deploys.com',
            'mydatahelps.org',
            'platform.joinallofus.org',
            'careevolution.dev',
            'ce.dev'
        ];
        this.accessTokenRenewalBufferSeconds = 120;
        this.apiBasePath = 'api/v1/delegated/';
        this.unsupportedActions = ["SetHeight", "ResearchKit"];
        this.supportedEvents = ["surveyDidFinish", "applicationDidBecomeVisible", "externalAccountSyncComplete", "tokenWillExpire"];
        this.currentMessageID = 1;
        this.messageHandlers = [];
        this.registeredEventHandlers = {};
        this.refreshTokenPromise = null;
        let mdh = this;
        let applicationHost = getParentOrigin();
        let supportedActions;
        function getParentOrigin() {
            let ancestorOrigins = document.location.ancestorOrigins;
            if (ancestorOrigins && ancestorOrigins[0]) {
                return ancestorOrigins[0];
            }
            return '*';
        }
        function acceptableOrigin(origin) {
            if (origin === '*')
                return true;
            let sourceURL = new URL(origin);
            for (let k = 0; k < mdh.allowedApplicationHosts.length; k++) {
                if (sourceURL.hostname === mdh.allowedApplicationHosts[k] || sourceURL.hostname.endsWith("." + mdh.allowedApplicationHosts[k])) {
                    return true;
                }
            }
            return false;
        }
        function validateWindowMessageOrigin(message) {
            if (applicationHost === "*") {
                return acceptableOrigin(message.origin);
            }
            return message.origin === applicationHost;
        }
        function receiveWindowMessage(message) {
            if (!validateWindowMessageOrigin(message)) {
                console.error("message.origin '" + message.origin + "' is not allowed.");
                throw "message.origin '" + message.origin + "' is not allowed.";
            }
            if (message.data.messageID) {
                mdh.setActionResult(message.data);
            }
            else {
                mdh.triggerEvent(message.data);
            }
        }
        if (!acceptableOrigin(applicationHost)) {
            console.error("Application is not hosted at an approved origin.");
            throw "Application is not hosted at an approved origin.";
        }
        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ResearchKit) {
            supportedActions = {
                "GetDelegatedAccessToken": function (data) {
                    window.parent.postMessage({
                        name: 'GetDelegatedAccessToken',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetDeviceInfo": function (data) {
                    window.parent.postMessage({ name: 'GetDeviceInfo', messageID: data.messageID }, applicationHost);
                }
            };
        }
        else {
            supportedActions = {
                "GetDelegatedAccessToken": function (data) {
                    window.parent.postMessage({
                        name: 'GetDelegatedAccessToken',
                        messageID: data.messageID
                    }, applicationHost);
                },
                "GetDeviceInfo": function (data) {
                    window.parent.postMessage({ name: 'GetDeviceInfo', messageID: data.messageID }, applicationHost);
                },
                "StartParticipantSurvey": function (data) {
                    window.parent.postMessage({
                        name: 'StartParticipantSurvey',
                        messageID: data.messageID,
                        surveyName: data.surveyName
                    }, applicationHost);
                },
                "OpenExternalLink": function (data) {
                    window.parent.postMessage({ name: 'OpenExternalUrl', url: data }, applicationHost);
                },
                "OpenEmbeddedLink": function (data) {
                    window.parent.postMessage({ name: 'OpenEmbeddedUrl', url: data }, applicationHost);
                },
                "OpenExternalApplication": function (data) {
                    window.parent.postMessage({
                        name: 'OpenApplication',
                        messageID: data.messageID,
                        url: data.url,
                        modal: data.modal
                    }, applicationHost);
                },
                "Dismiss": function () {
                    window.parent.postMessage({ name: 'Dismiss' }, applicationHost);
                },
                "PopNavigation": function () {
                    window.parent.postMessage({ name: 'Back' }, applicationHost);
                },
                "ShowTab": function (data) {
                    window.parent.postMessage({ name: 'ShowTab', tabKey: data }, applicationHost);
                },
                "ShowParticipantDashboard": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantDashboard',
                        dashboardKey: data.dashboardKey,
                        modal: data.modal
                    }, applicationHost);
                },
                "ShowParticipantWebVisualization": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantWebVisualization',
                        visualizationKey: data.visualizationKey,
                        parameters: data.parameters,
                        modal: data.modal
                    }, applicationHost);
                },
                "ShowParticipantWebVisualizationPDF": function (data) {
                    window.parent.postMessage({
                        name: 'ShowParticipantWebVisualizationPDF',
                        visualizationKey: data.visualizationKey,
                        parameters: data.parameters,
                        modal: data.modal,
                        landscape: data.landscape,
                        htmlViewerZoom: data.htmlViewerZoom
                    }, applicationHost);
                },
                "DeleteProviderAccount": function (data) {
                    window.parent.postMessage({
                        name: 'DeleteProviderAccount',
                        messageID: data.messageID,
                        accountID: data.accountID
                    }, applicationHost);
                },
                "ConnectExternalAccount": function (data) {
                    window.parent.postMessage({
                        name: 'ConnectExternalAccount',
                        externalAccountProviderID: data.externalAccountProviderID
                    }, applicationHost);
                },
                "ShowProject": function (data) {
                    window.parent.postMessage({ name: 'ShowProject', code: data.code }, applicationHost);
                },
                "JoinProject": function (data) {
                    window.parent.postMessage({ name: 'JoinProject', code: data.code }, applicationHost);
                }
            };
        }
        function windowHasAnyActions() {
            for (let action in supportedActions) {
                if (window.webkit.messageHandlers[action]) {
                    return true;
                }
            }
            for (let action in mdh.unsupportedActions) {
                if (window.webkit.messageHandlers[mdh.unsupportedActions[action]]) {
                    return true;
                }
            }
            return false;
        }
        if (!window.webkit || !window.webkit.messageHandlers || !windowHasAnyActions()) {
            window.webkit = {
                messageHandlers: {}
            };
        }
        for (let action in supportedActions) {
            window.webkit.messageHandlers[action] = window.webkit.messageHandlers[action] || { postMessage: supportedActions[action] };
        }
        window.addEventListener("message", receiveWindowMessage, false);
    }
    // Surveys
    startSurvey(surveyName) {
        let messageID = this.nextMessageID();
        window.webkit.messageHandlers.StartParticipantSurvey.postMessage({
            messageID: messageID,
            surveyName: surveyName
        });
    }
    completeStep(answer) {
        if (answer === undefined || answer === null)
            answer = '';
        if (window.webkit.messageHandlers.ResearchKit) {
            window.webkit.messageHandlers.ResearchKit.postMessage(answer);
        }
    }
    querySurveyAnswers(queryParameters) {
        if (queryParameters.hasOwnProperty("surveyName")) {
            queryParameters.surveyName = MyDataHelps.reduceArrayAndEscape(queryParameters.surveyName);
        }
        if (queryParameters.hasOwnProperty("stepIdentifier")) {
            queryParameters.stepIdentifier = MyDataHelps.reduceArrayAndEscape(queryParameters.stepIdentifier);
        }
        if (queryParameters.hasOwnProperty("resultIdentifier")) {
            queryParameters.resultIdentifier = MyDataHelps.reduceArrayAndEscape(queryParameters.resultIdentifier);
        }
        if (queryParameters.hasOwnProperty("answer")) {
            queryParameters.answer = MyDataHelps.reduceArrayAndEscape(queryParameters.answer);
        }
        if (queryParameters.hasOwnProperty("before")) {
            queryParameters.before = MyDataHelps.convertDateToIsoString(queryParameters.before);
        }
        if (queryParameters.hasOwnProperty("after")) {
            queryParameters.after = MyDataHelps.convertDateToIsoString(queryParameters.after);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'surveyanswers?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    deleteSurveyResult(resultID) {
        const endpoint = 'surveyresults/' + encodeURIComponent(resultID);
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'DELETE', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    querySurveyTasks(queryParameters) {
        if (queryParameters.hasOwnProperty("status")) {
            queryParameters.status = MyDataHelps.reduceArrayAndEscape(queryParameters.status);
        }
        if (queryParameters.hasOwnProperty("surveyName")) {
            queryParameters.surveyName = MyDataHelps.reduceArrayAndEscape(queryParameters.surveyName);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'surveytasks?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    startEmbeddedSurvey(linkIdentifier, surveyName, language) {
        if (!language) {
            language = this.getCurrentLanguage();
        }
        let surveyUrl = this.getBaseUrl() + "mydatahelps/" + linkIdentifier + '/surveylink/' + surveyName + "?lang=" + language;
        return this.startEmbeddedSurveyInternal(surveyUrl);
    }
    startEmbeddedTask(linkIdentifier, taskLinkIdentifier, language) {
        if (!language) {
            language = this.getCurrentLanguage();
        }
        let surveyUrl = this.getBaseUrl() + "mydatahelps/" + linkIdentifier + '/tasklink/' + taskLinkIdentifier + "?lang=" + language;
        return this.startEmbeddedSurveyInternal(surveyUrl);
    }
    // Navigation
    openExternalUrl(url) {
        window.webkit.messageHandlers.OpenExternalLink.postMessage(url);
    }
    openEmbeddedUrl(url) {
        window.webkit.messageHandlers.OpenEmbeddedLink.postMessage(url);
    }
    showTab(tabKey) {
        window.webkit.messageHandlers.ShowTab.postMessage(tabKey);
    }
    openApplication(url, options) {
        let messageID = this.nextMessageID();
        window.webkit.messageHandlers.OpenExternalApplication.postMessage({
            messageID: messageID,
            url: url,
            modal: !!(options && options.modal)
        });
    }
    dismiss() {
        window.webkit.messageHandlers.Dismiss.postMessage({});
    }
    back() {
        window.webkit.messageHandlers.PopNavigation.postMessage({});
    }
    showDashboard(dashboardKey, options) {
        window.webkit.messageHandlers.ShowParticipantDashboard.postMessage({
            dashboardKey: dashboardKey,
            modal: !!(options && options.modal),
            title: options && options.title ? options.title : undefined
        });
    }
    showWebVisualization(visualizationKey, parameters, options) {
        window.webkit.messageHandlers.ShowParticipantWebVisualization.postMessage({
            visualizationKey: visualizationKey,
            parameters: parameters,
            modal: !!(options && options.modal),
            title: options && options.title ? options.title : undefined
        });
    }
    showWebVisualizationPdf(visualizationKey, parameters, options) {
        window.webkit.messageHandlers.ShowParticipantWebVisualizationPDF.postMessage({
            visualizationKey: visualizationKey,
            parameters: parameters,
            landscape: !!(options && options.landscape),
            htmlViewerZoom: options && options.htmlViewerZoom
        });
    }
    showProject(projectCode) {
        if (window.webkit.messageHandlers.ShowProject) {
            window.webkit.messageHandlers.ShowProject.postMessage({ code: projectCode });
        }
    }
    joinProject(projectCode) {
        if (window.webkit.messageHandlers.JoinProject) {
            window.webkit.messageHandlers.JoinProject.postMessage({ code: projectCode });
        }
    }
    //Events
    on(eventName, callback) {
        if (!this.supportedEvents.includes(eventName)) {
            throw new Error(eventName + " is not a supported event type.");
        }
        if (!this.registeredEventHandlers[eventName]) {
            this.registeredEventHandlers[eventName] = [];
        }
        this.registeredEventHandlers[eventName].push(callback);
    }
    off(eventName, callback) {
        if (!this.supportedEvents.includes(eventName)) {
            throw new Error(eventName + " is not a supported event type.");
        }
        if (!this.registeredEventHandlers[eventName])
            return;
        let eventHandlerIndex = this.registeredEventHandlers[eventName].indexOf(callback);
        if (eventHandlerIndex !== -1) {
            this.registeredEventHandlers[eventName].splice(eventHandlerIndex, 1);
        }
    }
    triggerEvent(event) {
        let eventName = event.type;
        if (this.supportedEvents.includes(eventName) && this.registeredEventHandlers[eventName]) {
            this.registeredEventHandlers[eventName].forEach(function (handler) {
                handler(event);
            });
        }
    }
    setActionResult(data) {
        this.messageHandlers[data.messageID](data);
    }
    // Participant Info
    getParticipantInfo() {
        const mdh = this;
        const endpoint = 'participant';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    getProjectInfo() {
        const mdh = this;
        const endpoint = 'project';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // Device Data
    queryDeviceData(queryParameters) {
        if (queryParameters.hasOwnProperty("type")) {
            queryParameters.type = MyDataHelps.reduceArrayAndEscape(queryParameters.type);
        }
        if (queryParameters.hasOwnProperty("observedBefore")) {
            queryParameters.observedBefore = MyDataHelps.convertDateToIsoString(queryParameters.observedBefore);
        }
        if (queryParameters.hasOwnProperty("observedAfter")) {
            queryParameters.observedAfter = MyDataHelps.convertDateToIsoString(queryParameters.observedAfter);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'devicedata?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    persistDeviceData(deviceDataPoints) {
        const endpoint = 'devicedata';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', deviceDataPoints);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    // External Accounts
    getExternalAccountProviders(search, category, pageSize, pageNumber) {
        let searchParameters = {};
        if (!!search)
            searchParameters.search = search;
        if (!!category)
            searchParameters.category = category;
        if (!!pageSize)
            searchParameters.pageSize = pageSize;
        if (!!pageNumber)
            searchParameters.pageNumber = pageNumber;
        const queryString = new URLSearchParams(searchParameters).toString();
        const endpoint = 'externalaccountproviders?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    connectExternalAccount(externalAccountProviderID) {
        if (window.webkit.messageHandlers.ConnectExternalAccount) {
            window.webkit.messageHandlers.ConnectExternalAccount.postMessage({ externalAccountProviderID: externalAccountProviderID });
        }
    }
    getExternalAccounts() {
        const endpoint = 'externalaccounts';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    refreshExternalAccount(accountID) {
        const endpoint = 'externalaccounts/refresh/' + accountID;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    deleteExternalAccount(accountID) {
        let mdh = this;
        return new Promise(function (resolve, reject) {
            let messageID = mdh.nextMessageID();
            mdh.messageHandlers[messageID] = function (deleteProviderAccountResponse) {
                if (!deleteProviderAccountResponse.success) {
                    reject(deleteProviderAccountResponse);
                }
                else {
                    resolve(deleteProviderAccountResponse);
                }
            };
            if (window.webkit.messageHandlers.DeleteProviderAccount) {
                window.webkit.messageHandlers.DeleteProviderAccount.postMessage({
                    messageID: messageID,
                    accountID: accountID
                });
            }
            else {
                reject();
            }
        });
    }
    // Notifications
    queryNotifications(queryParameters) {
        if (queryParameters.hasOwnProperty("sentBefore")) {
            queryParameters.sentBefore = MyDataHelps.convertDateToIsoString(queryParameters.sentBefore);
        }
        if (queryParameters.hasOwnProperty("sentAfter")) {
            queryParameters.sentAfter = MyDataHelps.convertDateToIsoString(queryParameters.sentAfter);
        }
        const queryString = new URLSearchParams(queryParameters).toString();
        const endpoint = 'notifications?' + queryString;
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    // Authorization
    connect() {
        const mdh = this;
        let refreshDelegatedAccessToken = function () {
            mdh.token = null;
            mdh.refreshTokenPromise = new Promise(function (resolve, reject) {
                let messageID = mdh.nextMessageID();
                mdh.messageHandlers[messageID] = function (tokenResponse) {
                    if (tokenResponse.success) {
                        mdh.tokenExpires = Date.now() + (tokenResponse.data.expires_in * 1000);
                        mdh.token = tokenResponse.data;
                        mdh.baseUrl = tokenResponse.baseUrl;
                        setTimeout(refreshDelegatedAccessToken, ((tokenResponse.data.expires_in - mdh.accessTokenRenewalBufferSeconds) * 1000));
                        resolve(null);
                    }
                    else {
                        mdh.token = null;
                        reject(tokenResponse.message);
                    }
                    mdh.messageHandlers[messageID] = null;
                    mdh.refreshTokenPromise = null;
                };
                window.webkit.messageHandlers.GetDelegatedAccessToken.postMessage({ messageID: messageID });
            });
        };
        if (this.token && Date.now() < this.tokenExpires) {
            return Promise.resolve();
        }
        if (!this.refreshTokenPromise) {
            refreshDelegatedAccessToken();
        }
        // Re-use promise if refresh already in progress
        return this.refreshTokenPromise;
    }
    setParticipantAccessToken(token, baseUrl) {
        this.token = token;
        if (baseUrl) {
            this.baseUrl = baseUrl;
        }
        this.tokenExpires = Date.now() + (this.token.expires_in * 1000);
        const mdh = this;
        setTimeout(function () {
            mdh.triggerEvent({ type: "tokenWillExpire" });
        }, ((this.token.expires_in - this.accessTokenRenewalBufferSeconds) * 1000));
    }
    // Miscellaneous
    setStatusBarStyle(style) {
        if (window.webkit.messageHandlers.SetStatusBarStyle) {
            window.webkit.messageHandlers.SetStatusBarStyle.postMessage({ style: style });
        }
    }
    getDeviceInfo() {
        let mdh = this;
        return new Promise(function (resolve, reject) {
            let messageID = mdh.nextMessageID();
            mdh.messageHandlers[messageID] = function (deviceInfoResponse) {
                resolve(deviceInfoResponse.data);
            };
            if (window.webkit.messageHandlers.GetDeviceInfo) {
                window.webkit.messageHandlers.GetDeviceInfo.postMessage({ messageID: messageID });
            }
            else {
                reject();
            }
        });
    }
    getCurrentLanguage() {
        let searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has("lang")) {
            return searchParams.get("lang");
        }
        else {
            return navigator.language;
        }
    }
    showGoogleFitSettings() {
        if (window.webkit.messageHandlers.ShowGoogleFitSettings) {
            window.webkit.messageHandlers.ShowGoogleFitSettings.postMessage({});
        }
    }
    requestReview(cooldownDays) {
        if (window.webkit.messageHandlers.RequestReview) {
            window.webkit.messageHandlers.RequestReview.postMessage({ cooldownDays: cooldownDays });
        }
    }
    trackCustomEvent(event) {
        const endpoint = 'customevents';
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'POST', event);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function () {
            return;
        });
    }
    getDataCollectionSettings() {
        const mdh = this;
        const endpoint = 'datacollectionsettings';
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, 'GET', null);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return response.json();
        });
    }
    invokeCustomApi(customApi, method, queryParameters, jsonResponse) {
        if (customApi.includes('?')) {
            throw new Error("Cannot include query parameters directly in the \"customApi\" string. Provide as an argument for \"queryParameters\" instead.");
        }
        let endpoint = 'custom/' + customApi;
        method = method.toUpperCase();
        if (queryParameters !== null && queryParameters !== undefined && (method === 'GET' || method === 'DELETE')) {
            let parameterString = new URLSearchParams(queryParameters).toString();
            endpoint += "?" + parameterString;
            queryParameters = null;
        }
        const mdh = this;
        return this
            .connect()
            .then(function () {
            return mdh.makeRequest(endpoint, method, queryParameters);
        })
            .then(function (response) {
            return MyDataHelps.validateResponse(response);
        })
            .then(function (response) {
            return jsonResponse ? response.json() : undefined;
        });
    }
    nextMessageID() {
        return this.currentMessageID++;
    }
    getBaseUrl() {
        return this.baseUrl || 'https://mydatahelps.org/';
    }
    makeUrl(endpoint) {
        if (!this.baseUrl) {
            console.error("Cannot use makeUrl without MyDataHelps.baseUrl.");
            throw "Cannot use makeUrl without MyDataHelps.baseUrl.";
        }
        return this.baseUrl + this.apiBasePath + endpoint;
    }
    makeRequest(endpoint, method, body) {
        if (!this.token || !this.token.access_token) {
            throw "No access_token available for request authorization.";
        }
        let url = this.makeUrl(endpoint);
        let headers = new Headers();
        headers.append('Authorization', 'Bearer ' + this.token.access_token);
        headers.append('Accept', 'application/json, text/javascript, */*; q=0.01');
        headers.append('Accept-Language', this.getCurrentLanguage());
        if (!!body) {
            headers.append('Content-Type', 'application/json');
        }
        let init = {
            method: method,
            headers: headers
        };
        if (!!body) {
            init.body = JSON.stringify(body);
        }
        return fetch(url, init);
    }
    static validateResponse(response) {
        if (!response.ok) {
            throw response.statusText;
        }
        return response;
    }
    static escapeParam(param) {
        return String(param)
            .replace("\\", "\\\\")
            .replace(",", "\\,");
    }
    static reduceArrayAndEscape(param) {
        if (Array.isArray(param)) {
            let escapedParams = param.map(function (elem) {
                return MyDataHelps.escapeParam(elem);
            });
            return escapedParams.join(",");
        }
        return this.escapeParam(param);
    }
    static convertDateToIsoString(date) {
        let paramAsDate = new Date(date);
        if (isNaN(paramAsDate.getTime())) {
            throw "Cannot interpret parameter as Date";
        }
        return paramAsDate.toISOString();
    }
    startEmbeddedSurveyInternal(surveyUrl) {
        let mdhSurveyModalId = 'mydatahelps-survey-modal';
        let mdh = this;
        return new Promise(function (resolve, reject) {
            if (document.getElementById(mdhSurveyModalId)) {
                reject("Survey already in progress");
                return;
            }
            window.addEventListener("message", function listener(message) {
                if (message.origin !== new URL(mdh.getBaseUrl()).origin) {
                    return;
                }
                let frame = document.getElementById('mydatahelps-survey-frame').contentWindow;
                if (message.source !== frame) {
                    return;
                }
                if (message.data.name === 'SurveyWindowInitialized') {
                    document.getElementById(mdhSurveyModalId).className += " loaded";
                }
                else if (message.data.name === 'SurveyFinished') {
                    document.getElementById(mdhSurveyModalId).remove();
                    document.body.className = document.body.className.replace("no-scroll", "");
                    window.removeEventListener("message", listener, true);
                    resolve(message.data);
                }
            }, true);
            let surveyModal = document.createElement('div');
            surveyModal.className = 'mydatahelps-survey-modal';
            surveyModal.id = mdhSurveyModalId;
            surveyModal.innerHTML = "<div class='mydatahelps-survey'><div class='loader'>Loading...</div><iframe id='mydatahelps-survey-frame' allow='camera' sandbox='allow-forms allow-modals allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts' src='" + surveyUrl + "'></iframe></div>";
            document.body.append(surveyModal);
            document.body.className += ' no-scroll';
        });
    }
}
//iOS/Android directly invoke window.MyDataHelps and window.RKStudioClient
//so it's necessary to explicitly ensure they are present on the window
const mdh = new MyDataHelps();
window.MyDataHelps = mdh;
// For backwards compatibility
window.RKStudioClient = {};
window.RKStudioClient.setActionResult = function (data) {
    window.MyDataHelps.setActionResult(data);
};

export { MyDataHelps, mdh as default };
